import { render, staticRenderFns } from "./MaterialsList.vue?vue&type=template&id=8c5a52a6&scoped=true&"
import script from "./MaterialsList.vue?vue&type=script&lang=js&"
export * from "./MaterialsList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsList.vue?vue&type=style&index=0&id=8c5a52a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5a52a6",
  null
  
)

export default component.exports